// src/components/FixtureCardWithAnalytics.jsx
import React from 'react';
import FixtureCard from './FixtureCard';
import useFixtureAnalytics from '../hooks/useFixtureAnalytics';

/**
 * FixtureCard wrapper that automatically fetches analytics
 * @param {object} fixture - Fixture object
 * @param {boolean} showAnalytics - Whether to show analytics (default: true)
 * @param {boolean} enableAnalytics - Whether to fetch analytics (default: true for all leagues)
 * @param {function} onClick - Optional custom click handler
 * @param {string} className - Additional CSS classes
 */
export default function FixtureCardWithAnalytics({ 
  fixture, 
  showAnalytics = true,
  enableAnalytics = true,
  onClick,
  className 
}) {
  // Fetch analytics for all leagues (tier-based gating handled in MatchAnalyticsModal)
  const shouldFetchAnalytics = enableAnalytics;
  
  // Fetch analytics data
  const { analytics, loading, error } = useFixtureAnalytics(fixture, shouldFetchAnalytics);

  // Don't show analytics indicators while loading
  const displayAnalytics = showAnalytics && !loading && analytics;

  return (
    <FixtureCard
      fixture={fixture}
      analytics={displayAnalytics ? analytics : null}
      showAnalytics={displayAnalytics}
      onClick={onClick}
      className={className}
    />
  );
}
